import React from "react";
import UsageManualPDF from "../assets/files/manual-de-usuario.pdf";
export const UsageManual = () => {
  window.location.href = UsageManualPDF;
  return null;
}